import { useQuery } from '@tanstack/react-query';
import axios from '../../../services/axiosInstance';

const fetch = (url: string) => axios.get(url).then(r => r.data);

 export const useAllAnalytics = (
  gaId: string,
  startDate: string,
  endDate: string,
  enabled: boolean
) =>
  useQuery({
    queryKey: ['analytics', 'all', gaId, startDate, endDate],
    queryFn: () =>
      fetch(
        `/api/analytics/${encodeURIComponent(gaId)}/all?start_date=${startDate}&end_date=${endDate}`
      ),
    enabled: enabled && !!gaId && !!startDate && !!endDate,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });

